import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './vuex/store';
import VueHead from 'vue-head'
import "./registerServiceWorker";
import './assets/css/smartslider.scss'
import './assets/css/ama.scss'
import Lightbox from 'vue-pure-lightbox'
Vue.use(Lightbox)

// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'UA-146486703-1',
//   router
// })

Vue.use(VueHead)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
router.afterEach((to, from) => {
  ga('set', 'page', to.path);
  ga('send', 'pageview');
});